import { useState, useEffect } from 'react'
import FavoriteStar from '../../../../Components/Components/FavoriteStar'
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from '../../../../Helpers/CustomConverter'
import useGetProductPrices from '../../../../Components/BasketPage/Hooks/useGetProductPrices'
import ProductAvailabilityLevel from '../../../../Components/Components/ProductAvailabilityLevel'
import ProductBuyBtn from './ProductBuyBtn'
import { useCart } from '../../../../Providers/CartProvider'
import useHandleAddToBasketBtn from '../../Hooks/useHandleAddToBasketBtn'
import { ProductsWithSameSerial, RelatedProducts, SimilarProducts, SimilarProductsGrid } from './AdditionalProducts'
import { useAuth } from '../../../../Providers/AuthProvider'
import { useLastWatchedProducts } from '../../../../Providers/LastWatchedProductsProvider'
import { useNavigate } from 'react-router-dom'
import useGetProductIndexWithMask from '../../../../Components/BasketPage/Hooks/useGetProductIndexWithMask'
import NewPromoSellOutTag from '../../../../Components/Components/NewPromoSellOut/NewPromoSellOutTag'
import { useOffers } from '../../../../Providers/OffersProvider'
import useGetProductImage from '../../../../Hooks/useGetProductImage'

const ProductGrid = ({ product }) => {
    const navigate = useNavigate()
    const { authState } = useAuth()
    const { priceNet, priceGross } = useGetProductPrices(product)
    const { GetProductQuantityInCart, cartItems } = useCart()
    const { addProductToLastWatched } = useLastWatchedProducts()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const [quantityInCart, setQuantityInCart] = useState(0)
    const [quantity, setQuantity] = useState(product.salesRatio > 0 ? product.salesRatio : 1)
    const { handleBtnOnClick } = useHandleAddToBasketBtn(product, quantity)
    const { savedOfferId, getProductQuantityInSavedOffer, selectedSavedOffer } = useOffers()
    const { GetProductImage } = useGetProductImage()

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
        else {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [[], savedOfferId])

    useEffect(() => {
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow)
    }, [quantityInCart])

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [cartItems])

    useEffect(() => {
        if (savedOfferId != -1 && selectedSavedOffer && selectedSavedOffer.basketItems) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [selectedSavedOffer])

    const OnChange = (e) => {
        let value = e.target.value
        setQuantity(value)
    }
    const handleRedirect = () => {
        if (authState.user) {
            addProductToLastWatched(product.index)
        }
        navigate(`/product/${product.index}`)
    }

    return (
        <div className="product-grid-view">
            <div className="row">
                <div className="col d-flex align-items-start">
                    <FavoriteStar
                        isFavorite={product.isFavorite}
                        index={product.index}
                    />
                </div>
                <div className="col text-end">
                    <NewPromoSellOutTag product={product} />
                </div>
            </div>
            <div className="row mt-3 mb-3">
                <div className='product-grid-img element-pointer' onClick={handleRedirect}>
                    <GetProductImage
                        photoFileName={product.photoFileNames[0]}
                    />
                </div>
            </div>
            <div className="row d-flex element-pointer" style={{ minHeight: '220px' }} onClick={handleRedirect}>
                <span className='light-text-color'>{product.producent}</span>
                <span className='mt-2'>{CapitalizeFirstLowercaseRest(product.title)}</span>
                <span className='secondary-text mt-2'>{CapitalizeFirstLowercaseRest(product.label)}</span>
                <span className='light-text-color mt-2'>{getProductIndexWithMask(product.index)}</span>
            </div>
            <div className="row mt-2">
                <div className='d-flex'>
                    <b>{ConvertPriceToString(priceNet, product.currency)}</b>
                    <span className='ms-3'>{ConvertPriceToString(priceGross, product.currency)}</span>
                    <span className='ms-auto light-text-color'>{`${product.taxRate}%`}</span>
                </div>
            </div>
            <div className="row mt-2" style={{ minHeight: '48px' }}>
                <ProductAvailabilityLevel
                    product={product}
                />
            </div>
            <div className="row mt-2">
                <ProductBuyBtn
                    product={product}
                    quantityInCart={quantityInCart}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    OnChange={OnChange}
                    onClick={handleBtnOnClick}
                    isBasketSummary={false}
                    isProductDetail={true}
                />
            </div>
            {/* <div className="row">
                <ProductGridOtherProducts
                    product={product}
                />
            </div> */}
        </div>
    )
}

// const ProductGridOtherProducts = ({ product }) => {
//     const [isMobile, setIsMobile] = useState(() => {
//         if (typeof window !== 'undefined') {
//             return window.matchMedia('(max-width: 700px)').matches
//         }
//         return false
//     })

//     useEffect(() => {
//         const mq = window.matchMedia('(max-width: 700px)')
//         const handler = (e) => setIsMobile(e.matches)
//         mq.addEventListener('change', handler)
//         setIsMobile(mq.matches)

//         return () => {
//             mq.removeEventListener('change', handler)
//         }
//     }, [])

//     const [isPopupSimilarVisible, setIsPopupSimilarVisible] = useState(false)
//     const [isPopupSerialVisible, setIsPopupSerialvisible] = useState(false)
//     const [isPopupRelatedVisible, setIsPopupRelatedVisible] = useState(false)

//     const togglePopupVisibility = (type) => {
//         switch (type) {
//             case 'Seria':
//                 setIsPopupSerialvisible(prevState => !prevState)
//                 setIsPopupSimilarVisible(false)
//                 setIsPopupRelatedVisible(false)
//                 return
//             case 'Podobne':
//                 setIsPopupSimilarVisible(prevState => !prevState)
//                 setIsPopupSerialvisible(false)
//                 setIsPopupRelatedVisible(false)
//                 return
//             case 'Powiazane':
//                 setIsPopupRelatedVisible(prev => !prev)
//                 setIsPopupSerialvisible(false)
//                 setIsPopupSimilarVisible(false)
//                 return
//             default:
//                 setIsPopupSimilarVisible(false)
//                 setIsPopupSerialvisible(false)
//                 setIsPopupRelatedVisible(false)
//         }
//     }

//     const relatedVisibility = product.hasRelated ? '' : 'collapse'
//     const similarVisibility = product.hasSimilar ? '' : 'collapse'
//     const seriesVisibility = product.hasSeries ? '' : 'collapse'
//     //const hasSetVisibility = product.hasSet ? '' : 'collapse'

//     if (!product.hasRelated && !product.hasSimilar && !product.hasSeries && !product.hasSet) {
//         return null
//     }
//     if (!isMobile) {
//         return null
//     }
//     return (<>
//         <div className='col d-flex g-4 align-items-center'>
//             <div className={`d-flex flex-grow-1 justify-content-center`}>
//                 {/* <div className={`${} products-additional me-3`}>Sprawdź w zestawie</div> */}
//                 <div className={`${relatedVisibility} products-additional me-3 ${isPopupRelatedVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Powiazane')}>Powiązane</div>
//                 <div className={`${seriesVisibility} products-additional me-3 ${isPopupSerialVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Seria')}>Seria</div>
//                 <div className={`${similarVisibility} products-additional me-3 ${isPopupSimilarVisible ? 'active' : ''}`} onClick={() => togglePopupVisibility('Podobne')}>Podobne</div>
//             </div>
//         </div>
//         <div className={`row additional ${isPopupSimilarVisible ? 'show' : 'hide'}`}>
//             <div className='col'>
//                 <div className='row'>
//                     {isPopupSimilarVisible && <SimilarProducts product={product} isMobile={true} />}
//                 </div>
//             </div>
//         </div>
//         <div className={`row additional ${isPopupSerialVisible ? 'show' : 'hide'}`}>
//             <div className='col'>
//                 <div className='row'>
//                     {isPopupSerialVisible && <ProductsWithSameSerial product={product} isMobile={true} />}
//                 </div>
//             </div>
//         </div>
//         <div className={`row additional ${isPopupRelatedVisible ? 'show' : 'hide'}`}>
//             <div className='col'>
//                 <div className='row'>
//                     {isPopupRelatedVisible && <RelatedProducts product={product} isMobile={true} />}
//                 </div>
//             </div>
//         </div>
//     </>)
// }

export default ProductGrid